<template>
  <div class="Subpage">
    <Bigmenu
      :NavStatus="Bignav"
      :Way="0"
      :ShowBackBtn="true"
      v-on:cellback="OpenStatus"
      style="z-index: 2"
    ></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Submenu
      v-if="!Bignav"
      :Info="SubInfo"
      :DividNum="4"
      :BGImgUrl="'sbg0103.png'"
      :Submenu="Submenu"
      v-on:cellback="Navgo"
      style="z-index: -6"
    ></Submenu>
    <router-view />
  </div>
</template>

<script>
import Bigmenu from "@/components/Bigmenu.vue";
import Back from "@/components/Back.vue";
import Submenu from "@/components/Submenu.vue";
export default {
  name: "A01",
  data() {
    return {
      Bignav: false,
      SubInfo: {
        title: "我們的願景",
        body: ""
      },
      Submenu: [
        {
          id: "01",
          text: "提升患者體驗"
        },
        {
          id: "02",
          text: "簡化臨床工作流程"
        },
        {
          id: "03",
          text: "讓創新觸手可及"
        },
        {
          id: "04",
          text: "實現個人化照護"
        }
      ]
    };
  },
  components: {
    Back,
    Submenu,
    Bigmenu
  },
  methods: {
    Navgo(v) {
      switch (v) {
        case 0:
          this.$router.push("/A0101");
          break;
        case 1:
          this.$router.push("/A0102");
          break;
        case 2:
          this.$router.push("/A0103");
          break;
        case 3:
          this.$router.push("/A0104");
          break;
      }
    },
    OpenStatus(v) {
      this.Bignav = v.status;
    }
  }
};
</script>
<style lang="scss" scoped>
.Subpage {
  height: 100%;
  width: 100%;
}
.frame {
  position: absolute;
  background-image: url("../../assets/frame.png");
  background-position: center;
  height: 1080px;
  width: 1920px;
}
</style>
